import { resolveVarStoreExpression } from "../../component/VARSTORE/varStoreExpression";

const GLOBAL_VARIABLE_PATTERN = /\[\[([\s\S]*?)\]\]/g;
const ROW_VALUE_PATTERN = /\{([^{}]+)\}/g;

const replaceGlobalVariables = (value, globalVariables = {}) =>
  String(value ?? "").replace(GLOBAL_VARIABLE_PATTERN, (match, variableName) => {
    const resolvedValue = globalVariables?.[variableName.trim()];

    return resolvedValue === undefined || resolvedValue === null
      ? match
      : String(resolvedValue);
  });

export const resolveDataGridRowVariables = (
  variableDefinitions = [],
  row = {},
  globalVariables = {}
) => {
  const resolvedVariables = {};

  (Array.isArray(variableDefinitions) ? variableDefinitions : []).forEach(definition => {
    const variableName = definition?.sName?.trim();

    if (!variableName) return;

    const expression = replaceGlobalVariables(
      definition?.sValue,
      globalVariables
    );

    resolvedVariables[variableName] = resolveVarStoreExpression(expression, {
      ...row,
      ...resolvedVariables
    });
  });

  return resolvedVariables;
};

export const resolveDataGridRowAction = (
  actionTemplate,
  row = {},
  variableDefinitions = [],
  globalVariables = {}
) => {
  if (actionTemplate === undefined || actionTemplate === null) {
    return actionTemplate;
  }

  const resolvedVariables = resolveDataGridRowVariables(
    variableDefinitions,
    row,
    globalVariables
  );
  const values = { ...row, ...resolvedVariables };
  const globallyResolvedTemplate = replaceGlobalVariables(
    actionTemplate,
    globalVariables
  );

  return globallyResolvedTemplate.replace(ROW_VALUE_PATTERN, (match, fieldName) => {
    const resolvedValue = values?.[fieldName.trim()];

    return resolvedValue === undefined || resolvedValue === null || resolvedValue === ""
      ? match
      : String(resolvedValue);
  });
};
